import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { MaskLine } from "./Reveal";

const EASE = [0.22, 1, 0.36, 1];

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], [0, 90]);

  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative mx-auto flex min-h-[100svh] max-w-[1240px] flex-col justify-center px-6 pb-20 pt-36 md:px-10 md:pt-32"
    >
      <div className="grid items-center gap-12 md:grid-cols-[1.05fr_0.95fr] md:gap-16">
        <div className="order-2 md:order-1">
          <p className="mb-8 font-sans text-xs uppercase tracking-[0.2em] text-sage">
            Индивидуальные чтения Human Design
          </p>

          <h1 data-testid="hero-logo" className="text-charcoal">
            <MaskLine index={0}>
              <img
                src="/logo.png"
                alt="Olga Scherbich — Human Design | Personal Guide"
                className="w-[11.2rem] mix-blend-multiply sm:w-[12.6rem] lg:w-56"
              />
            </MaskLine>
          </h1>

          <p className="mt-14 max-w-lg font-sans text-[1.35rem] font-light leading-relaxed text-charcoal/75">
            Помогаю находить свой ориентир
            <br />и принимать решения в согласии с собой
            <br />через Human Design.
          </p>

          <div className="mt-12">
            <a
              href="#booking"
              data-testid="hero-cta"
              className="group inline-flex items-center gap-3 bg-charcoal px-9 py-4 font-sans text-sm text-ivory transition-colors duration-300 hover:bg-sage"
            >
              Записаться на консультацию
              <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.25, duration: 1.3, ease: EASE }}
          className="order-1 md:order-2"
        >
          <div className="relative overflow-hidden">
            <motion.div style={{ y: imgY }}>
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_olga-clarity/artifacts/qgp90jxe_Olga0185_%282%29%201.webp"
                alt="Ольга Щербич — Human Design"
                data-testid="hero-portrait"
                className="aspect-[4/5] w-full object-cover object-top"
              />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
